const isDev = import.meta.env.DEV;

export const logger = {
  info: (...args: unknown[]) => { if (isDev) console.log('[INFO]', ...args); },
  warn: (...args: unknown[]) => { if (isDev) console.warn('[WARN]', ...args); },
  error: (...args: unknown[]) => { console.error('[ERROR]', ...args); },
  debug: (...args: unknown[]) => { if (isDev) console.debug('[DEBUG]', ...args); },
};
